import {useCallback, useEffect, useState} from "react"
import {useDispatch} from "react-redux"
import {setMessage} from "../store/appReducer"
import {catchError} from "../store/sliceHelper"
import {CommonResponse} from "../api/API"

type ApiResponse<T> = Promise<CommonResponse<T>>

export function createFetchHook<TApiFunc extends (params?: any) => ApiResponse<any>>(apiFunc: TApiFunc) {
    type TParams = Parameters<TApiFunc>[0]
    type TData = Awaited<ReturnType<TApiFunc>> extends { data: infer R } ? R : never

    return function useFetchData(params?: TParams) {
        const dispatch = useDispatch()
        const [items, setItems] = useState<TData | null>(null)

        const fetchData = useCallback(async () => {
            try {
                const res = await apiFunc(params)
                if (res.status === 0) {
                    setItems(res.data)
                } else {
                    dispatch(setMessage({ type: "error", message: res.message }))
                }
            } catch (e: any) {
                catchError(e, dispatch)
            }
        }, [dispatch, params])

        useEffect(() => {
            fetchData()
        }, [fetchData])

        return items
    }
}